import { gql } from '@ts-gql/tag';

import type { TokenRefreshHandler } from '@reckon-web/gql-api-client';
import { skipAuthErrorHandlingContext } from '@reckon-web/gql-api-client';

const RefreshAuthTokenMutation = gql`
  mutation RefreshAuthTokenMutation($refreshToken: String!) {
    reAuthenticatePortalUser(refreshToken: $refreshToken) {
      token
      refreshToken
    }
  }
` as import('../../../__generated__/ts-gql/RefreshAuthTokenMutation').type;

export type RefreshTokenMutationProps = typeof RefreshAuthTokenMutation['___type']['variables'];
export type RefreshTokenMutationResult = typeof RefreshAuthTokenMutation['___type']['result']['reAuthenticatePortalUser'];

export const refreshAuthTokenMutation: TokenRefreshHandler = async (input) => {
  const result = await input.client.mutate({
    mutation: RefreshAuthTokenMutation,
    variables: {
      refreshToken: input.refreshToken,
    },
    // This mutation is the recovery. Were its own UNAUTHENTICATED answer routed
    // back into recovery, it would start another refresh through the same link
    // instead of rejecting so that the caller can sign out.
    context: skipAuthErrorHandlingContext,
  });

  const authenticated = result.data?.reAuthenticatePortalUser;
  if (!authenticated) {
    throw Error('Unable to authenticate user');
  }

  // The API calls the access token `token`; the credential store and the
  // request headers read `accessToken`.
  return {
    accessToken: authenticated.token,
    refreshToken: authenticated.refreshToken,
  };
};
